import { useState, useCallback } from "react";

type FeedbackType = "note" | "probleme";

interface UserFeedbackPayload {
  feedbackType: FeedbackType;
  note?: number; // obligatoire si type 'note'
  commentaire?: string;
  problemeType?: string; // obligatoire si type 'probleme'
  message?: string;
}

interface UseUserFeedbackResult {
  sendFeedback: (payload: UserFeedbackPayload) => Promise<void>;
  loading: boolean;
  error: string | null;
  success: boolean;
}

export function useUserFeedback(): UseUserFeedbackResult {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const sendFeedback = useCallback(async (payload: UserFeedbackPayload) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const resp = await fetch("/api/user-feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) {
        const errData = await resp.json().catch(() => null);
        throw new Error(errData?.error || `Erreur serveur: ${resp.status}`);
      }

      setSuccess(true);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Erreur inconnue");
    } finally {
      setLoading(false);
    }
  }, []);

  return { sendFeedback, loading, error, success };
}
